import React from 'react'

export default (props) => <svg
	{...props}
	width="100%"
	height="119px"
	preserveAspectRatio="none"
	viewBox="0 0 1440 119"
	fill="none"
	xmlns="http://www.w3.org/2000/svg">
	<path fill-rule="evenodd"
		  clip-rule="evenodd"
		  d="M0 26.1754V0H1440V118.723C1291.48 73.151 1087.08 45.6599 984.404 84.9314C878.472 125.447 691.421 119.758 603.913 71.293C540.468 36.1541 482.003 55.8351 423.583 75.5008C401.427 82.9591 379.278 90.4152 356.866 94.8778C285.737 109.041 122.18 69.7362 0 26.1754Z"
	/>
</svg>
